/*
 Create by fanglijuan  2017-5-19
 */
"use strict";
angular.module("typeClassifySettingPageManageModule", [
        'typeclassifySettingPageManageServiceModule'
    ])
    .controller("typeClassifySettingPageManageCtrl", ["$scope", "typeclassifySettingPageManageService", "$q", "$stateParams", '$state', "$location", 'trsHttpService', 'modalDialog', 'productMangageMentNewspaperService', 'getNewsNameService', '$modal', 'trsspliceString',
        function($scope, typeclassifySettingPageManageService, $q, $stateParams, $state, $location, trsHttpService, modalDialog, productMangageMentNewspaperService, getNewsNameService, $modal, trsspliceString) {
            initStatus();
            initData();
            /**
             * [getSiteRights description]获取每个站点的操作权限
             * @return null [description]
             */
            function getSiteRights() {
                productMangageMentNewspaperService.getRight($stateParams.paper, "", "papersetpaper").then(function(data) {
                    $scope.status.right = data;
                });
            }
            //初始化状态
            function initStatus() {
                $scope.params = {
                    "serviceid": "mlf_paperset",
                    "methodname": "queryCaiBianCategory",
                    "PaperId": $stateParams.paper
                };
                $scope.selectedArray = [];
                getNewsNameService.getNewsName($stateParams.paper).then(function(data) {
                    $scope.channelName = data.SITEDESC;
                });
                $scope.status = {
                    right: {},
                    item: ''
                };
                /*$scope.items = [];*/
                getSiteRights();
            }

            //初始化数据
            function initData() {
                requestData();
            }

            function requestData() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get").then(function(data) {
                    $scope.items = data;
                    $scope.selectedArray = [];
                });
            }
            /**
             * [sort description]排序
             * @return {[type]} [description]
             */
            $scope.sort = function() {
                if ($scope.selectedArray.length !== 1) {
                    modalDialog.alertType("请仅选择一个频道", "", "warning", false);
                    return;
                }
                var index = $scope.items.indexOf($scope.selectedArray[0]) + 1;
                /*typeclassifySettingPageManageService.sortType("newspaper", index, $scope.selectedArray[0], $scope.items, function(data) {
                    if (data.ISSUCCESS == "true") {
                        $state.go($state.current.name, $stateParams, { reload: true });
                    }
                });*/
                $scope.sortInfo = {
                    oldPosition: index, //原所在位置（列表序号）
                    curItemName: $scope.selectedArray[0].CATEGORYNAME, //当前需要调整排序的选项的名称
                    allCounts: $scope.items.length, //列表总数
                    objId: $scope.selectedArray[0].CAIBIANCATEGORYID, //站点、栏目id
                    objType: 101, //站点:103;栏目:101
                    params: {
                        serviceid: "mlf_paperset",
                        methodname: "recordCaiBianCategory",
                        Position: "", //新位置
                        CategoryId: $scope.selectedArray[0].CAIBIANCATEGORYID, //站点、栏目id
                    },
                }
                productMangageMentNewspaperService.commOrder($scope.sortInfo, function() {
                    requestData();
                });
            };
            //全选
            $scope.selectAll = function() {
                $scope.selectedArray = $scope.selectedArray.length == $scope.items.length ? [] : [].concat($scope.items);
            };

            //单选
            $scope.selectDoc = function(item) {
                //item.selected ? $scope.selectedArray.push(item) : $scope.selectedArray.splice($scope.selectedArray.indexOf(item), 1);
                if ($scope.selectedArray.indexOf(item) < 0) {
                    $scope.selectedArray.push(item);
                } else {
                    $scope.selectedArray.splice($scope.selectedArray.indexOf(item), 1);
                }
            };
            //停用启用
            $scope.stopOrStart = function(item) {
                //启用
                if (item.STATUS == "-1") {
                    modalDialog.confirmModal('提示信息', "确定启用？", function() {
                        var params = {
                            serviceid: "mlf_paperset",
                            methodname: "startCaiBianCategory",
                            CategoryId: item.CAIBIANCATEGORYID
                        };
                        // $scope.params.serviceid = "mlf_paperset";
                        // $scope.params.methodname = "startUserCategory";
                        // $scope.params.CategoryId = item.CAIBIANCATEGORYID;
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                            requestData();
                        });

                    });
                }
                //停用
                if (item.STATUS == "1") {
                    modalDialog.confirmModal('提示信息', "确定停用？", function() {
                        // $scope.params.serviceid = "mlf_paperset";
                        // $scope.params.methodname = "stopUserCategory";
                        // $scope.params.CategoryId = item.CAIBIANCATEGORYID;
                        // requestData();
                        var params = {
                            serviceid: "mlf_paperset",
                            methodname: "stopCaiBianCategory",
                            CategoryId: item.CAIBIANCATEGORYID
                        };
                        // $scope.params.serviceid = "mlf_paperset";
                        // $scope.params.methodname = "startUserCategory";
                        // $scope.params.CategoryId = item.CAIBIANCATEGORYID;
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                            requestData();
                        });

                    });
                }
            };
            //新建分类
            $scope.newClassify = function() {
                var params = {
                    ObjectId: 0,
                    PaperId: $stateParams.paper,
                    type: '新建分类',
                    length: $scope.items.length,
                    index: 1
                };
                newOrEditClassify(params);
            };

            //修改分类
            $scope.editClassify = function(item) {
                var params = {
                    ObjectId: item.CAIBIANCATEGORYID,
                    PaperId: item.PAPERID,
                    type: '编辑分类',
                    length: $scope.items.length,
                    index: $scope.items.indexOf(item) + 1
                };
                newOrEditClassify(params);
            };
            //新建or修改：根据分类id
            function newOrEditClassify(params) {
                typeclassifySettingPageManageService.addType(params).then(function(data) {
                    requestData();
                }, function(data) {
                    //失败
                });
            }

            //单个删除
            $scope.singleDelete = function(item) {
                modalDialog.confirmModal('删除', "确认删除?", function() {
                    deleteFun(item.CAIBIANCATEGORYID);
                });
            };

            //批量删除
            $scope.batchDelete = function() {
                var items = trsspliceString.spliceString($scope.selectedArray,'CAIBIANCATEGORYID', ',');
                modalDialog.confirmModal('提示信息', "确认删除?", function() {
                    deleteFun(items);
                });
                // var modalInstance = $modal.open({
                //     templateUrl: "./manageConfig/productManageMent/newspaper/alertViews/classifyDel/classifyDel_tpl.html",
                //     windowClass: "classifyDelClass",
                //     backdrop: false,
                //     controller: "productManageMentClassifyDelCtrl",
                //     scope: $scope,
                //     resolve: {
                //         delItems: function() {
                //             return $scope.selectedArray;
                //         },
                //         title: function() {
                //             return "删除";
                //         }
                //     }
                // });
                // modalInstance.result.then(function() {
                //     var delArray = trsspliceString.spliceString($scope.selectedArray,
                //         'CAIBIANCATEGORYID', ',');
                //     deleteFun(delArray);
                // });
            };

            //删除方法
            function deleteFun(item) {
                var params = {
                    "serviceid": "mlf_paperset",
                    "methodname": "deleteCaiBianCategory",
                    "ObjectIds": item
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    modalDialog.alertType("删除成功", "", "success", false, function() {
                        requestData();
                    });
                }, function() {
                    requestData();
                });
            }
        }

    ]);
